import styled from 'styled-components';

import Button from '../../../components/Button';

const LoadingWrapper = styled.div`
    width: 100%;
    height: 360px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ControlBar = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    flex-direction: row;
    justify-content: flex-end;
`;

const AlertContainer = styled.div`
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const AddButton = styled(Button)`
`;

export { LoadingWrapper, AddButton, ControlBar, AlertContainer };
